module.exports = __webpack_public_path__ + "img/about-banner.b5d8aee4.jpg";